module.exports = __webpack_public_path__ + "img/Small-Semi-Elliptical-Attachment-R-37.9ec88dbe.png";